/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminStationCreateInput } from "../../entities/models/AdminStationCreateInput";
import { z } from "zod/v4";

export const modelsAdminStationCreateInputSchema = z.object({
    "branch_id": z.optional(z.int()),
"is_active": z.optional(z.boolean()),
"name": z.string()
    }) as unknown as z.ZodType<ModelsAdminStationCreateInput>